var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgError = function SvgError(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 8.25,
    stroke: "currentColor",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5794 8.36034C14.8723 8.06739 15.347 8.06739 15.6399 8.36034C15.9327 8.6533 15.9327 9.12827 15.6399 9.42122L13.0615 12.0007L15.6408 14.5812C15.9337 14.8741 15.9337 15.3491 15.6408 15.6421C15.348 15.935 14.8732 15.935 14.5804 15.6421L12.001 13.0616L9.42166 15.6421C9.12883 15.935 8.65406 15.935 8.36123 15.6421C8.06839 15.3491 8.06839 14.8741 8.36123 14.5812L10.9406 12.0007L8.36219 9.42122C8.06936 9.12827 8.06936 8.6533 8.36219 8.36034C8.65502 8.06739 9.1298 8.06739 9.42263 8.36034L12.001 10.9398L14.5794 8.36034Z",
    fill: "currentColor"
  })));
};
export default SvgError;